/* ============ 挽留折扣倒计时（6 天） ============ */
var now = Date.now();
var deadline = 0;

try {
    deadline = Number(window.localStorage.getItem('mobieark_uninstall_deadline')) || 0;
} catch (error) {
    deadline = 0;
}

if (deadline < now) {
    deadline = now + 6 * 24 * 60 * 60 * 1000;

    try {
        window.localStorage.setItem('mobieark_uninstall_deadline', deadline);
    } catch (error) { }
}

// 数字补零，保证倒计时显示为两位
var pad = function (num) {
    return num < 10 ? '0' + num : '' + num;
};

var countdown = function () {
    var left = Math.max(0, deadline - Date.now());
    var $time = $('.countdown p span');

    $time.eq(0).text(pad(Math.floor(left / 86400000)));
    $time.eq(1).text(pad(Math.floor(left % 86400000 / 3600000)));
    $time.eq(2).text(pad(Math.floor(left % 3600000 / 60000)));
    $time.eq(3).text(pad(Math.floor(left % 60000 / 1000)));
};

countdown();
setInterval(countdown, 1000);
